import React from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Partials/Footers/HomeOne/Footer";

const NotFound = () => {
  return (
    <>
      <div className="not-found-hero">
        <div className="not-found-hero-content">
          <div className="not-found-number">404</div>
          <h1 className="not-found-title">Faqja nuk u gjet</h1>
          <div className="not-found-subtitle">
            Na ndjeni, faqja që po kërkoni nuk ekziston ose është zhvendosur
          </div>
          <div className="not-found-actions">
            <Link to="/" className="btn btn-primary">
              Kthehu në Ballina
            </Link>
            <Link to="/category/lajme" className="btn btn-outline">
              Shiko Lajmet e Fundit
            </Link>
          </div>
        </div>
      </div>

      <div className="not-found-container">
        <div className="not-found-content">
          <div className="not-found-section">
            <h2 className="not-found-subtitle">Çfarë mund të bëni tani?</h2>
            <div className="suggestions-grid">
              <div className="suggestion-card">
                <div className="suggestion-icon">🏠</div>
                <div className="suggestion-content">
                  <h3 className="suggestion-title">Kthehu në Ballina</h3>
                  <p className="suggestion-description">
                    Shiko lajmet më të fundit dhe përmbajtjen kryesore të faqes
                  </p>
                </div>
              </div>

              <div className="suggestion-card">
                <div className="suggestion-icon">🔍</div>
                <div className="suggestion-content">
                  <h3 className="suggestion-title">Përdor Kërkimin</h3>
                  <p className="suggestion-description">
                    Gjej përmbajtjen që po kërkoni duke përdorur kërkimin e
                    faqes
                  </p>
                </div>
              </div>

              <div className="suggestion-card">
                <div className="suggestion-icon">📰</div>
                <div className="suggestion-content">
                  <h3 className="suggestion-title">Shiko Kategoritë</h3>
                  <p className="suggestion-description">
                    Eksploro kategoritë e ndryshme të lajmeve që ofrojmë
                  </p>
                </div>
              </div>

              <div className="suggestion-card">
                <div className="suggestion-icon">📞</div>
                <div className="suggestion-content">
                  <h3 className="suggestion-title">Na Kontakto</h3>
                  <p className="suggestion-description">
                    Nëse mendoni se ka një gabim, na kontaktoni për ndihmë
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="not-found-section">
            <div className="error-details">
              <p className="error-text">
                Nëse keni arritur këtu duke ndjekur një lidhje nga faqja jonë,
                ju lutemi na raportoni gabimin që të mund ta rregullojmë.
              </p>
              <p className="error-text">
                Nëse keni shkruar URL-në manualisht, ju lutemi kontrolloni
                shkrimin dhe provoni përsëri.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NotFound;
